import React from 'react'
import {useTranslation} from 'react-i18next'
import {Typography, TypographyProps} from '@mui/material'
import DOMPurify from 'dompurify'

interface ColoredWordTextProps extends Omit<TypographyProps, 'children'> {
  i18nKey: string
  params?: {[key: string]: string | number}
}

const TransCustom: React.FC<ColoredWordTextProps> = ({
  i18nKey,
  params,
  ...otherProps
}) => {
  const {t} = useTranslation()
  const localizedString = t(i18nKey, params || {})
  const sanitizedHtml = DOMPurify.sanitize(localizedString)

  return (
    <Typography
      {...otherProps}
      dangerouslySetInnerHTML={{__html: sanitizedHtml}}
    />
  )
}

export default React.memo(TransCustom)
